var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel panel-left events-contact",
      class: { hidden: !_vm.visible }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "bar",
              rawName: "v-bar",
              value: {
                preventParentScroll: true,
                overrideFloatingScrollbar: false
              },
              expression:
                "{ preventParentScroll: true, overrideFloatingScrollbar: false }"
            }
          ],
          staticClass: "events-container",
          style: { display: _vm.contactVisible ? "none" : "block" }
        },
        [
          _c("div", [
            _vm.upcomingEvents && _vm.upcomingEvents.length
              ? _c(
                  "div",
                  {
                    ref: "upcoming",
                    staticClass: "upcoming",
                    style: {
                      marginTop:
                        "calc(50vh - " + (_vm.upcomingHeight + 30) + "px)"
                    }
                  },
                  [
                    _c("strong", [_vm._v("Upcoming")]),
                    _c("br"),
                    _vm._v(" "),
                    _vm._l(_vm.upcomingEvents, function(event) {
                      return _c(
                        "div",
                        { key: event.id, staticClass: "event" },
                        [
                          _vm._v(
                            "\n          " + _vm._s(event.date) + "\n          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(event.description) +
                              "\n        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pastEvents && _vm.pastEvents.length
              ? _c(
                  "div",
                  {
                    ref: "past",
                    staticClass: "past",
                    style: {
                      marginTop:
                        !_vm.upcomingEvents || !_vm.upcomingEvents.length
                          ? "calc(50vh - " +
                            Math.min(_vm.pastHeight + 30, _vm.maxHeight) +
                            "px)"
                          : "0"
                    }
                  },
                  [
                    _c("strong", [_vm._v("Past")]),
                    _c("br"),
                    _vm._v(" "),
                    _vm._l(_vm.pastEvents, function(event) {
                      return _c(
                        "div",
                        { key: event.id, staticClass: "event" },
                        [
                          _vm._v(
                            "\n          " + _vm._s(event.date) + "\n          "
                          ),
                          _c("br"),
                          _vm._v(_vm._s(event.description) + "\n        ")
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "contact-container",
          style: { display: _vm.contactVisible ? "block" : "none" }
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.contact) } })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }